var _circle, _ellipse, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEqualizeWorktimeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D7F5E8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 31.494,
    rx: 18,
    ry: 18.2857,
    fill: "#5AD6A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0012 23.3666V31.7548L37.5 37.5889",
    stroke: "#D8FFEE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.2305,
    y: 15.4958,
    width: 1.54286,
    height: 3.00587,
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2305,
    y: 44.4916,
    width: 1.54286,
    height: 3.00587,
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.752,
    y: 30.7458,
    width: 1.50294,
    height: 3.08571,
    transform: "rotate(90 47.752 30.7458)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.50294,
    height: 3.08571,
    transform: "matrix(4.41713e-08 1 1 -4.32562e-08 16.2402 30.7458)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(0.716313 0.697779 -0.716313 0.697779 43.1387 20.0084)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(-0.716313 0.697779 0.716313 0.697779 20.8535 20.0084)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(-0.716313 0.697779 0.716313 0.697779 41.5039 40.6917)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(0.716313 0.697779 -0.716313 0.697779 22.4883 40.6917)",
    fill: "#99EDC9",
    stroke: "#99EDC9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEqualizeWorktimeActive);
export default __webpack_public_path__ + "static/media/img_equalize_worktime_active.553c5e79af7a6ca4ce4a7acf2a6f6102.svg";
export { ForwardRef as ReactComponent };